export default __webpack_public_path__ + "static/media/bol_scan_8.1492d2a8.svg";